import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2A312B] text-[#F9F8F6] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <img src="/logo-museum-graphia.png" alt="Museum Graphia · Museo internazionale della stampa" className="h-24 w-auto bg-white p-2" data-testid="footer-logo-museum" />
            <img src="/logo-corte-white.png" alt="La Corte della Miniera · Arte Artigianato Agriturismo" className="h-20 w-auto" data-testid="footer-logo-corte" />
          </div>
          <div className="overline text-[#D7B565] mt-6">Urbino · dal 1980</div>
          <h3 className="font-display text-3xl mt-3">Corte della Miniera</h3>
          <p className="text-sm text-[#F9F8F6]/70 mt-4 max-w-md leading-relaxed">
            Struttura ricettiva e Museum Graphia, museo internazionale della stampa.
            Un luogo dove artigianato, formazione e ospitalità si intrecciano nel cuore delle Marche.
          </p>
        </div>
        <div>
          <div className="overline text-[#D7B565]">Esplora</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/museum-graphia" className="hover:text-[#D7B565]">Museum Graphia</Link></li>
            <li><Link to="/servizi" className="hover:text-[#D7B565]">Servizi & Laboratori</Link></li>
            <li><Link to="/progetti" className="hover:text-[#D7B565]">Progetti Formativi</Link></li>
            <li><Link to="/progetti-sartoriali" className="hover:text-[#D7B565]">Sartoriale</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-[#D7B565]">Contatti</div>
          <ul className="mt-4 space-y-2 text-sm text-[#F9F8F6]/80">
            <li>Via Miniera 10 · 61029 Urbino (PU)</li>
            <li><a href="tel:+393665959253" className="hover:text-[#D7B565]">+39 366 595 9253</a></li>
            <li><a href="mailto:info@cortedellaminiera.it" className="hover:text-[#D7B565]">info@cortedellaminiera.it</a></li>
            <li><a href="https://www.cortedellaminiera.it" className="hover:text-[#D7B565]">cortedellaminiera.it</a></li>
            <li className="pt-2 flex gap-3">
              <a href="https://www.instagram.com/cortedellaminiera" target="_blank" rel="noopener noreferrer" className="hover:text-[#D7B565]">Instagram</a>
              <span className="text-[#F9F8F6]/30">·</span>
              <a href="https://www.facebook.com/cortedellaminiera" target="_blank" rel="noopener noreferrer" className="hover:text-[#D7B565]">Facebook</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F9F8F6]/10 py-5 px-6 flex flex-col sm:flex-row items-center justify-between gap-3 max-w-[1400px] mx-auto lg:px-10 text-xs text-[#F9F8F6]/50">
        <span>© {new Date().getFullYear()} Corte della Miniera · Museum Graphia</span>
        <Link to="/login" data-testid="footer-area-riservata" className="inline-flex items-center gap-2 border border-[#F9F8F6]/25 rounded-full px-4 h-9 text-[#F9F8F6]/80 hover:text-[#D7B565] hover:border-[#D7B565] transition-colors">
          <Lock size={13} /> Area riservata
        </Link>
      </div>
    </footer>
  );
}
